// TODO 路由守卫可以处理一下事情
import router from "./router"
import baseLayout from './base.vue';
import store from "./store";
import domMessage from '@/messageOnce';

// 路由守卫
// 在循环之前的操作
router.beforeEach((to, from, next) => {
    if (localStorage.needEdit == 'true') { //判断是否有修改密码
        if (to.path !== '/employee-editMyPassword' && to.path !== '/login' && (localStorage.loginRoletype.indexOf('adm') == -1)) {
            //提示一次的实例
            let messageOnce = new domMessage();
            messageOnce.warning({
                message: '请先修改初始密码！'
            })
            return next({
                path: '/employee-editMyPassword'
            })
        }
    }
    if (window.location.pathname == '/candidate' || window.location.pathname == '/resume' || window.location.pathname == '/editResume' || window.location.pathname == '/matching' || window.location.pathname == '/eleApplication' || window.location.pathname == '/empApplication' || window.location.pathname == '/interviewApplication' || window.location.pathname == '/insuranceH5' || window.location.pathname == '/bgApplication' || window.location.pathname == '/qwNotify' || window.location.pathname == '/register'|| window.location.pathname == '/chat' || window.location.pathname == '/hello') {
        next()
    } else {
        // console.log("routerhook", store.state.menu.router);
        let firstPath
        let firstRoute
        if (localStorage.router) {
            // firstRoute = JSON.parse(localStorage.router)
            // firstPath = firstRoute[0].path
            firstPath = "/staging"
        } else {
            firstPath = "/login"
        }
        // console.log('firstPath', firstPath[0].path)
        //有token
        if (Cookies.get("userid-b")) {
            if (to.path === "/login") {
                next({
                    path: firstPath[0].path
                })
            } else {
                if (store.state.menu.router.length === 0) {
                    // 如果不是登录页面 需要去重新获取一下路由
                    try {
                        let activeRouter = JSON.parse(localStorage.router)
                        let arrayRouter = []
                        generaMenu(arrayRouter, activeRouter)
                        // for (let index = 0; index < activeRouter.length; index++) {
                        //     let item = activeRouter[index];
                        //     let parentComponent = baseLayout //父级组件
                        //     let childrenComponent //子级组件
                        //     let one = {
                        //         path: item.path,
                        //         name: item.name,
                        //         meta: item.meta,
                        //         component: parentComponent,
                        //         checked: false,
                        //         powercode: item.powercode,
                        //         powermsg: item.powermsg,
                        //         powername: item.powername,
                        //         powerEnName: item.powerEnName,
                        //         children: []
                        //     };
                        //     for (let i = 0; i < item.children.length; i++) {
                        //         let itemkid = item.children[i];
                        //         itemkid.meta.checked = false
                        //         // if (itemkid.powerEnName == 'customManage' || itemkid.powerEnName == 'financeManage' || itemkid.powerEnName == 'projectManage' || itemkid.powerEnName == 'doc' || itemkid.powerEnName == 'supplierManage') {
                        //             childrenComponent = (resolve) => require([`@/views/${itemkid.powerEnName}${itemkid.path}`], resolve)
                        //         // } else {
                        //         //     childrenComponent = (resolve) => require([`@/${itemkid.powerEnName}${itemkid.path}`], resolve)
                        //         // }
                        //         let kid = {
                        //             path: itemkid.path,
                        //             name: itemkid.name,
                        //             component: childrenComponent,
                        //             meta: itemkid.meta,
                        //             powercode: itemkid.powercode,
                        //             powermsg: itemkid.powermsg,
                        //             powername: itemkid.powername,
                        //             powerEnName: itemkid.powerEnName
                        //         };
                        //         one.children.push(kid);
                        //     }
                        //     arrayRouter.push(one)
                        // }
                        router.addRoutes(arrayRouter)
                        // console.log("router",arrayRouter)
                        store.dispatch("SetRouter", arrayRouter);
                        // 跳转
                        next({
                            ...to,
                            replace: true
                        })
                    } catch (error) {
                        console.log(error)
                        store.state.login = false;
                        next({
                            path: "/login"
                        })
                    }
                } else {
                    next()
                }
            }
        } else {
            //么有token
            store.state.login = false;
            // next({ path: "/login" })
        }
    }
})

function generaMenu(routes, data) {
    // console.log('generaMenu', data)
    data.forEach(item => {
        // console.log('sss', item)
        let menu = {
            path: item.path === '#' ? item.path + '_key' : item.path,
            component: (item.children && item.children.length > 0) ? baseLayout : (resolve) => require([`@/views/${item.powerEnName}${item.path}`], resolve),
            // hidden: true,
            // redirect: 'noRedirect',
            // alwaysShow: false,
            checked: false,
            activeMenu: '',
            children: [],
            name: item.name,
            powerEnName: item.powerEnName,
            powercode: item.powercode,
            powername: item.powername,
            meta: {
                title: item.meta.title,
                checked: false,
                icon: item.meta.icon,
                //   noCache: true,
                //   breadcrumb: true,
                //   affix: false
            }
        }
        if (item.children && item.children.length > 0) {
            generaMenu(menu.children, item.children)
        }
        routes.push(menu)
    })
}